import { render, staticRenderFns } from "./Interest.vue?vue&type=template&id=85e67db6"
import script from "./Interest.vue?vue&type=script&lang=js"
export * from "./Interest.vue?vue&type=script&lang=js"
import style0 from "./Interest.vue?vue&type=style&index=0&id=85e67db6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports